import { PositionProps } from 'styled-system';
import { convertPropsToStyle } from './properties';

const POSITION_PROPS = ['top', 'bottom', 'left', 'right', 'position', 'zIndex'];

/**
 * Position related styles for styled components
 *
 * @param props - render props
 */
export const position = convertPropsToStyle<PositionProps>(POSITION_PROPS);
